package com.swetdot.swetgram.ui.design

import androidx.compose.foundation.clickable
import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.swetdot.swetgram.ui.theme.SwetgramThemeTokens
import org.jetbrains.compose.resources.stringResource
import swetgram.shared.generated.resources.Res
import swetgram.shared.generated.resources.premium_badge_description

/** Navigation action supplied once by the authenticated app shell. Null keeps previews inert. */
internal val LocalOpenSwetgramBlack = staticCompositionLocalOf<(() -> Unit)?> { null }

/** Compact public mark; the backend decides whether the subscriber is allowed to expose it. */
@Composable
fun SwetBlackBadge(
    modifier: Modifier = Modifier,
    size: Dp = 16.dp,
    opensPremium: Boolean = true,
    tint: Color? = null,
) {
    val openPremium = LocalOpenSwetgramBlack.current
    SwetIcon(
        icon = SwetIcons.Crystal,
        tint = tint ?: SwetgramThemeTokens.colors.textPrimary,
        contentDescription = stringResource(Res.string.premium_badge_description),
        size = size,
        modifier = if (opensPremium && openPremium != null) {
            modifier.clickable(
                role = Role.Button,
                onClick = openPremium,
            )
        } else {
            modifier
        },
    )
}
